import { registerTab } from "lib/@components/tabs"
import { REGIME_ASSETS_TAB } from "routes/asset-register/plugins/regime-display/regime-display.runtime"
import { UpdatedSFG20 } from "routes/asset-register/plugins/schedules-out-of-date/updated-sfg20"
import { and } from "lib/logic"
import { isInEditableRegime } from "routes/facilities/lib/when-parent-item"
import { isEnabled } from "lib/@components/feature"
import { FEATURE_FLAG_ASSET_MAPPING_SCHEDULE_LIBRARY_UPDATES } from "routes/asset-register/feature-flag-asset-mapping"

registerTab({
    tab: REGIME_ASSETS_TAB,
    id: "updated-schedules",
    title: "Schedule Library Updates",
    predicate: and(isInEditableRegime, () => isEnabled(FEATURE_FLAG_ASSET_MAPPING_SCHEDULE_LIBRARY_UPDATES)),
    content: <UpdatedSFG20 $lazy priority={170} />,
})
